let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '操作时间',
        props: 'createdTime',
        minWidth: 200,
        tooltip:true,
    },
    {
        label: '操作参数',
        props: 'paramsJson',
        minWidth: 420,
    },
    {
        label: '操作结果',
        props: 'resultJson',
        minWidth: 420,
    },
    {
        label: '操作模块',
        props: 'module',
        minWidth: 180,
    },
    {
        label: '操作人',
        props: 'operatorName',
        minWidth: 180,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '系统管理'
},
{
    type: 'title',
    name: '操作日志'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 路由
pageConfig.listRouter = 'push_log_list';

export default pageConfig;